'use client';

import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { PatientSelectionModalKeys } from '@/app/(main)/_components/patient-selection/_types/patient-selection-modal-keys.enum';
import { Icon } from '@/components/ui/icon.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { useProgressiveModal } from '@/components/ui/progressive-modal/progressive-modal.hook';
import { DependentForm } from '@/app/(main)/(pages)/(auth)/dependentes/_components/dependent-form.component';

export function PatientSelectionCreate() {
  const { handleJump, onClose } = useProgressiveModal<PatientSelectionModalKeys>();
  const backToList = () => handleJump({ key: PatientSelectionModalKeys.LIST, returning: true });

  return (
    <div className="flex flex-col gap-3 p-5" data-testid={DataTestIdEnum.PATIENT_SELECTION_CREATE_STEP}>
      <div className="flex items-start justify-between gap-2">
        <Typography variant={TypographyVariant.MODAL_TITLE}>Criar dependente</Typography>
        <button
          type="button"
          aria-label="Fechar modal"
          data-testid={DataTestIdEnum.PATIENT_SELECTION_CREATE_STEP_CLOSE_BUTTON}
          className="shrink-0 flex size-8 items-center justify-center cursor-pointer"
          onClick={onClose}
        >
          <Icon icon={faTimes} className="text-gray-500 hover:text-gray-900 text-2xl" />
        </button>
      </div>
      <DependentForm onSuccessCallback={backToList} onBack={backToList} />
    </div>
  );
}
